import { useEffect, useState } from 'react';
import { ModalStyle } from '../../../styles/components/common/ui';
export interface IModalProps {
  show?: boolean;
  isSmall?: boolean;
  children: React.ReactNode;
}

export interface IModalSectionProps {
  children: React.ReactNode;
  className?: string;
}

const ModalHeader = (props: IModalSectionProps) => {
  return (
    <div
      className={`${ModalStyle['modal-header']} ${
        props.className ? props.className : ''
      }`}>
      {props.children}
    </div>
  );
};

const ModalContent = (props: IModalSectionProps) => {
  return (
    <div
      className={`${ModalStyle['modal-content']} ${
        props.className ? props.className : ''
      }`}>
      {props.children}
    </div>
  );
};

const ModalFooter = (props: IModalSectionProps) => {
  return (
    <div
      className={`${ModalStyle['modal-footer']} ${
        props.className ? props.className : ''
      }`}>
      {props.children}
    </div>
  );
};

const Modal = (props: IModalProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);

  useEffect(() => {
    if (props.show) {
      setIsVisible(true);
      setIsAnimatingOut(false);
    } else if (isVisible) {
      setIsAnimatingOut(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        setIsAnimatingOut(false);
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [props.show, isVisible]);

  if (!isVisible) {
    return null;
  }

  const animationClass = isAnimatingOut
    ? ModalStyle['animate-out']
    : ModalStyle['animate-in'];

  return (
    <div
      className={`${ModalStyle['modal']} ${animationClass} ${
        props.isSmall ? ModalStyle['modal-small'] : ''
      }`}>
      <div className={ModalStyle['modal-container']}>{props.children}</div>
    </div>
  );
};

export default Modal;
export { ModalContent, ModalFooter, ModalHeader };
